import { Tooltip } from "antd"
import { pencil_img } from "../../assets/images"
import { useHistory } from "react-router-dom"
import MisApi from "../../services/mis.api"
import { successOrFailureToaster } from "../../components/common/atoms/messages"

/** User-facing label for MIS pulse_type (matches AddMisPulse pulse types + legacy). */
export const pulseTypeDisplayName = (pulseType) => {
  if (pulseType == null || pulseType === '') return ''
  const map = {
    opd: 'OPD',
    opd_v2: 'OPD',
    utilization: 'Utilization',
    utilization_v2: 'Utilization',
    opd_utilization: 'Both'
  }
  return map[pulseType] ?? String(pulseType)
}

const misPulseSchema = ({data, setRefresh}) => {
  const history = useHistory()

  const deactivateMisPulse = () => {
    MisApi.deactivateMisPulse(
      { id: data.id },
      (res) => {
        successOrFailureToaster({ message: 'Mis Pulse deactivated successfully' });
        history.push('/mis-pulse');
        setRefresh(true);
      },
      (err) => {
        successOrFailureToaster({ message: 'Operation failed', type: 'error' });
      }
    );
  }

  const activateMisPulse = () => {
    MisApi.activateMisPulse(
      { id: data.id },
      (res) => {
        successOrFailureToaster({ message: 'Mis Pulse activated successfully' });
        history.push('/mis-pulse');
        setRefresh(true);
      },
      (err) => {
        successOrFailureToaster({ message: 'Operation failed', type: 'error' });
      }
    );
  }

  const formatToCommaSeparated = (array) => {
    if (!Array.isArray(array) || array.length === 0) return "";
    let fullText = array.join(", ");
    const maxLength = 70;
    return fullText.length > maxLength ? fullText.slice(0, maxLength) + "..." : fullText;
  };

  const formatMappings = (array) => formatToCommaSeparated(array) || '-'

  const editMis = ()=>{
    history.push({pathname : 'mis-pulse/add', state : {data : data}})
  }

  return (
    <tr className='text-gray-600' key={data.id} >
      <td className={`pl-3 py-4 w-8 break-words `}>
          {data.frequency}
      </td>
      <td className={`pl-3 pr-4 py-4 w-8`}>{pulseTypeDisplayName(data.pulse_type)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4`}>{formatToCommaSeparated(data.benefits)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4`}>{formatToCommaSeparated(data.sids)}</td>
       <td className={`pl-3 pr-4 py-4 w-1/4 break-words `}>
        {formatMappings(data.mappings)}
       </td>
       <td className={`pl-3 pr-4 py-4 w-1/4 break-words `}>
        {formatMappings(data.opd_mappings)}
       </td>
       <td className='content-center w-1/4'>
       <div className="flex flex-row flex-wrap p-3" >
          { (data.status === 'active' || data.status === 'inactive') && <span onClick={() => editMis()} className='px-3.5 relative align-middle cursor-pointer'> <Tooltip  placement='bottom' title='Edit mis pulse' ><img src={pencil_img}/></Tooltip></span> }
          { (data.status == 'draft' || data.status == 'inactive') && <span className={`px-2.5 py-1.5 2xl:py-2.5 2xl:px-3 self-center hover:bg-blue-100 rounded-md cursor-pointer`}> <Tooltip placement='bottomRight' overlayStyle={{maxWidth : '1000px'}} title={'Activate mis pulse'}><button className={`text-blue-600 text-sm font-medium cursor-pointer `} onClick={() => activateMisPulse()}>Activate</button></Tooltip></span> }
          { data.status == 'active' && <span className={`px-2.5 py-1.5 2xl:py-2.5 2xl:px-3 self-center hover:bg-blue-100 rounded-md cursor-pointer`}> <Tooltip placement='bottomRight' overlayStyle={{maxWidth : '1000px'}} title={'Deactivate mis pulse'}><button className={`text-blue-600 text-sm font-medium cursor-pointer `} onClick={() => deactivateMisPulse()}>Deactivate</button></Tooltip></span> }
        </div>
        </td>
    </tr>
  )
}

export default misPulseSchema
